module.exports = __webpack_public_path__ + "54ddc74a9b802388bffe40a5120b1a10.png";